/* eslint-disable complexity */
import {
  claimSherpaSimTransmit,
  claimTransmit,
  detectRefusal,
  getClaim,
  uploadSherpaDocument,
  workflowSherpaSimTransmit,
} from 'app/modules/claim/service/claim-service';
import { RESET_CLAIM } from 'app/modules/claim/service/store/claim-actions';
import { ClaimState } from 'app/modules/claim/service/store/claim-state';
import { loadModalContent, loadPageContent } from 'app/modules/cms/service/cms-service';
import { addBehaviors, removeBehavior, removeBehaviors, startLoading, stopLoading } from 'app/modules/cms/service/store/cms-dispatchs';
import { redirectToLounge } from 'app/modules/externalApp/service/lounge-service';
import { geoLocationPostAction } from 'app/modules/geolocation/service/geolocation-services';
import { gtmEvent, initializeGtmTagSteps } from 'app/modules/gtm/service/gtm.service';
import { gtmStepsMapper } from 'app/modules/gtm/utils/gtm-mappers';
import { NO, YES } from 'app/shared/constants/constants';
import { CoverCode } from 'app/shared/constants/cover-code';
import { ContactDTO } from 'app/shared/model/contactDTO.model';
import { GeolocationPostActionDTO } from 'app/shared/model/geolocationPostActionDTO.model';
import { updateClient } from 'app/shared/reducers/kubrick-management';
import { isEmptyObject } from 'app/shared/util/method-util';
import { stepEngineApi } from '../api/step-engine-api';
import { CustomerEntryName, ModalConstants, PagePart, Step, StepEngineBehaviorsConstants, StepEngineStepGroup} from '../utils/step-engine-constants';
import { createFirstContact } from './client-service';
import { RESET_STEP_ENGINE } from './store/step-engine-actions';
import {
  addCustomerEntry,
  addGlobalData,
  addNextStepToStepList,
  addRepeatableGlobalData,
  decrementCurrentRepeatableStepGroup,
  decrementLastRepeatableStepGroup,
  removeCustomerEntry,
  removeDeclarationGlobalData,
  removeRepeatableGlobalData,
  removeStepFromStepList,
  removeStepFromStepListByIndexAndName,
  removeStepsFromStepListAfterIndex,
  setBackToHome,
  setCover,
  setCoverDisplayName,
  setCurrentRepeatableStepGroup,
  setCurrentStep,
  setCurrentStepGroup,
  setDontShowPopupRedirectUrl,
  setLastEditStep,
  setLastRepeatableStepGroup,
  setReceivedStep,
  setShowErrorModal,
  setShowRatingModal,
  setShowStepAction,
  setStepGroup
} from './store/step-engine-dispatchs';
import { behaviorStepExist, manageModal, nextBehaviorExist } from './utils/services-utils';
import { StepList } from './store/step-engine-state';
import { CreateWorkflowDTO } from 'app/shared/model/createWorkflowDTO.model';

export const unremovedStepsBehaviors = dataKey => {
  switch (dataKey) {
    case PagePart.SIDE_BAR_MOBILE:
      return true;
    default:
      return false;
  }
};

export const resetStepEngine = () => (dispatch, getState) => {
  const { cmsContent, isMobile } = getState().cms;

  Object.keys(cmsContent).map(function (cmsKey) {
    if (!unremovedStepsBehaviors(cmsKey) && cmsContent[cmsKey]?.behaviors) {
      dispatch(removeBehaviors(cmsKey));
    }
  });
  dispatch({ type: RESET_STEP_ENGINE });
  dispatch({ type: RESET_CLAIM });
  dispatch(addGlobalData('mobile', isMobile));
};

// Test du behaviors pour execution de resetStepEngine
export const checkResetStepEngine = (behaviors: any) => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.[StepEngineBehaviorsConstants.RESET_STEP_ENGINE]) {
    dispatch(resetStepEngine());
  }
};

//
export const checkIdProductCard = (behaviors: any) => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.idProductCard) {
    dispatch(addCustomerEntry(CustomerEntryName.ID_PRODUCT_CARD, behaviors.idProductCard));
  }
};

// Test du behaviors pour execution de la création du sinistre
export const findClaim = claimNumber => async dispatch => {
  await dispatch(getClaim(claimNumber));
};

// Ajoute un event gtm suite à une action de navigation Suivant/Précédent
const addGtmEventFromNavigation = (currentSteps, cmsContent, eventAction: string) => dispatch => {
  // Récupération et concaténation des gtmLabel
  const gtmLabels = currentSteps
    .filter(cs => cmsContent[Step[cs]]?.prismic?.gtmLabel)
    .map(cs => cmsContent[Step[cs]]?.prismic?.gtmLabel)
    .join(' & ');
  if (gtmLabels) dispatch(gtmEvent(gtmLabels, eventAction, '0'));
};

export const getPreviousStep = () => async (dispatch, getState) => {
  const { stepData, globalData, stepList } = getState().stepEngine;
  const { cmsContent } = getState().cms;
  const { lastRepeatableStepGroup } = getState().stepEngine.stepData;
  const currentStepIndexStore = stepList.findIndex(x => x.stepName === stepData.currentSteps[0] && x.insuredGroupIndex === stepData.currentRepeatableStepGroup);
  const { currentSteps } = stepData;

  if (behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.DEPOSIT_METHOD)) {
    dispatch(removeBehavior(Step[currentSteps[0]], StepEngineBehaviorsConstants.DEPOSIT_METHOD));
  }

  if (behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP)) {
    dispatch(setCurrentStep(cmsContent[Step[currentSteps[0]]]?.behaviors?.goToPreviousStep));
    dispatch(removeBehavior(Step[currentSteps[0]], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP));
  } else {
    if (stepList.length > 0) {
      if (stepList[currentStepIndexStore - 1].stepName === 'GET_FIRST_STEP') {
        dispatch(setBackToHome(true));
      } else {
        const previousStep = stepList[currentStepIndexStore - 1].stepName; // Obligé de déclaré car précédement index possiblement < 0
        currentSteps.forEach(currentStep => {
          if (Step[previousStep] === Step.COVER_SELECTION || Step[currentStep] === Step.COVER_SELECTION) {
            dispatch(addCustomerEntry(CustomerEntryName.COVER_CHOICE, null));
            dispatch(setCover(null));
          }
        });
        if (cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover) {
          dispatch(
            addCustomerEntry(
              CustomerEntryName.COVER_CHOICE,
              cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover
            )
          );
          dispatch(setCover(cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover));

          const coverObject = {
            ...globalData[Step.COVER_SELECTION],
            code: CoverCode[cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover],
            value: cmsContent[Step[currentSteps[currentSteps.length - 1]]]?.behaviors?.previousCover,
          };
          dispatch(addGlobalData(Step.COVER_SELECTION, coverObject));
          dispatch(addBehaviors(Step[currentSteps[currentSteps.length - 1]], { previousStep: null }));
        }
        if (previousStep) {
          // GTM Action Précédent
          dispatch(addGtmEventFromNavigation(currentSteps, cmsContent, 'Précédent'));
          // Set the new current step and update the view
          currentSteps.forEach(currentStep => {
            dispatch(removeDeclarationGlobalData(Step[currentStep]));
          });

          // Si on provient d'une step répétable (sens logique)
          if (stepData.currentRepeatableStepGroup !== null &&
            (stepList[currentStepIndexStore - 1].insuredGroupIndex === null || stepList[currentStepIndexStore - 1].insuredGroupIndex < stepData.currentRepeatableStepGroup)) {
            await dispatch(decrementLastRepeatableStepGroup())
            await dispatch(decrementCurrentRepeatableStepGroup())
          // Spécificité pour le summary et les steps non répétables qui se trouvent après les steps répétables
          } else if (stepData.currentRepeatableStepGroup === null && stepList[currentStepIndexStore - 1].insuredGroupIndex !== null) {
            await dispatch(setCurrentRepeatableStepGroup(stepList[currentStepIndexStore - 1].insuredGroupIndex))
          }
          if(stepList[currentStepIndexStore].stepName === "DECLARATION_SUMMARY"){
            // dispatch(setCurrentRepeatableStepGroup(lastRepeatableStepGroup));
            dispatch(setCurrentStep([stepList[currentStepIndexStore - 1].stepName]));
            dispatch(removeStepsFromStepListAfterIndex(currentStepIndexStore - 1));
            dispatch(setCurrentStepGroup(StepEngineStepGroup.COVERAGE));
            dispatch(setLastEditStep(Step.METHOD_OF_PAYMENT_CONFIRMATION));
            dispatch(removeRepeatableGlobalData("declareAnotherDamage", stepList[currentStepIndexStore - 1].insuredGroupIndex));
            dispatch(removeCustomerEntry(CustomerEntryName.DECLARE_ANOTHER_DAMAGE));
          } else{
            const previousStepArr = [previousStep]
            dispatch(setCurrentStep(previousStepArr));
            dispatch(removeStepFromStepList(currentStepIndexStore));
          }
          return true;
        }
      }
      return false;
    }
  }
};

export const computeStepEngineDatas = (dataKey: Step, dataValue: any, reset?: boolean) => dispatch => {
  if ((dataValue !== null && dataValue !== undefined) || reset) {
    switch (dataKey) {
      case Step.CUSTOMER_INFORMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_FIRST_NAME, dataValue.firstName));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_LAST_NAME, dataValue.lastName));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_EMAIL, dataValue.email));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_PHONE, dataValue.phone));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_BIRTH_DATE, dataValue.birthDate));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_NATIVE_COUNTRY, dataValue.nativeCountry));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_BIRTH_CITY, dataValue.birthCity));
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_CIVILITY, dataValue.civility));
        if(dataValue.adressePostal != null){
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_CITY, dataValue.adressePostal.city));
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_ADDRESS, dataValue.adressePostal.address));
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_POSTAL_CODE, dataValue.adressePostal.postalCode));
          dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_STREET_NUMBER, dataValue.adressePostal.streetNumber));
        }
        break;
      }
      case Step.DAMAGED_GOOD_CIRCONSTANCES: {
        dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_CIRCONSTANCES, dataValue));
        break;
      }
      case Step.CONCERNED_DAMAGED_GOOD: {
        dispatch(addCustomerEntry(CustomerEntryName.CONCERNED_DAMAGED_GOOD, dataValue?.id));
        break;
      }
      case Step.JOURNEY_HOME_PAGE: {
        dispatch(addCustomerEntry(CustomerEntryName.JOURNEY_ROUTE_SELECTED, dataValue?.value));
        break;
      }
      case Step.COVER_SELECTION: {
        dispatch(setCover(dataValue?.value));
        dispatch(setCoverDisplayName(dataValue?.label));
        dispatch(addCustomerEntry(CustomerEntryName.COVER_CHOICE, dataValue?.value));
        dispatch(addCustomerEntry(CustomerEntryName.COVER_CHOICE_CODE, dataValue?.code));

        break;
      }
      case Step.STOLEN_TYPE_SELECTION: {
        dispatch(addCustomerEntry(CustomerEntryName.STOLEN_TYPE_CHOICE, dataValue?.value));
        break;
      }
      case Step.BURGLARY_DEVICE_SELECTION: {
        dispatch(addCustomerEntry(CustomerEntryName.LOCATION_TYPE_CHOICE, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_DATE: {
        dispatch(addCustomerEntry(CustomerEntryName.INCIDENT_DATE, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_TIME: {
        dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_TIME, dataValue));
        break;
      }
      case Step.PURCHASE_VALUE: {
        dispatch(addCustomerEntry(CustomerEntryName.PURCHASE_VALUE, dataValue));
        break;
      }
      case Step.DAMAGED_GOOD_FAMILY: {
        dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_TYPE, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_CREATION: {
        dispatch(addCustomerEntry(CustomerEntryName.SELECTED_INSURED_GOOD, reset ? undefined : -1));
        break;
      }
      case Step.DAMAGED_GOOD_SELECTION: {
        if (Object.keys(dataValue).length > 0) {
          dispatch(addCustomerEntry(CustomerEntryName.OTHER_DAMAGED_GOOD_SELECTION, reset ? undefined : NO));
          dispatch(addCustomerEntry(CustomerEntryName.SELECTED_INSURED_GOOD, JSON.stringify(dataValue[0])));
          dispatch(
            addCustomerEntry(CustomerEntryName.BRAND_SELECTED_INSURED_GOOD, reset ? undefined : String(dataValue[0]?.brand).toUpperCase())
          );
          dispatch(
            addCustomerEntry(CustomerEntryName.MODEL_SELECTED_INSURED_GOOD, reset ? undefined : String(dataValue[0]?.model).toUpperCase())
          );
        } else {
          dispatch(addCustomerEntry(CustomerEntryName.OTHER_DAMAGED_GOOD_SELECTION, reset ? undefined : YES));
        }
        break;
      }
      case Step.DAMAGED_GOOD_IMEI_VALIDATION:
      case Step.DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION: {
        dispatch(addCustomerEntry(CustomerEntryName.IMEI_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_USER_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.USER_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.EXTERNAL_DAMAGE_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.EXTERNAL_DAMAGE_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.CLIENT_DETAILS_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.CORDINATES_UPDATE, dataValue?.value));
        break;
      }
      case Step.CLAIM_TRIGGER_NATURE: {
        if (reset) dispatch(addCustomerEntry(CustomerEntryName.CLAIM_TRIGGER_NATURE, undefined));
        else {
          let stringArray = '';
          if (dataValue instanceof Array) {
            stringArray = dataValue
              .map(item => {
                return item.code;
              })
              .join(',');
          } else {
            stringArray = dataValue.code;
          }
          dispatch(addCustomerEntry(CustomerEntryName.CLAIM_TRIGGER_NATURE, stringArray));
        }
        break;
      }
      case Step.CLAIM_RESULT_SELECTION: {
        if (reset) dispatch(addCustomerEntry(CustomerEntryName.CLAIM_RESULT_SELECTION, undefined));
        else {
          let stringArray = '';
          if (dataValue instanceof Array) {
            stringArray = dataValue
              .map(item => {
                return item.code;
              })
              .join(',');
          } else {
            stringArray = dataValue.code;
          }
          dispatch(addCustomerEntry(CustomerEntryName.CLAIM_RESULT_SELECTION, stringArray));
        }
        break;
      }
      case Step.CLAIM_DECLARATION_DATE: {
        dispatch(addCustomerEntry(CustomerEntryName.INCIDENT_DATE, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.PROPER_USE_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.PROPER_FUNCTIONING_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.REPARATION_PERIOD_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE: {
        dispatch(addCustomerEntry(CustomerEntryName.REPARATION_PERIOD_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.PRODUCT_IN_POCKET_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.POCKET_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.BENEFIT_TYPE_SELECTION: {
        dispatch(addCustomerEntry(CustomerEntryName.BENEFIT_TYPE_SELECTION, dataValue?.value));
        break;
      }
      case Step.BENEFIT_DEPOSIT_METHOD: {
        dispatch(addCustomerEntry(CustomerEntryName.DEPOSIT_METHOD, dataValue?.value));
        break;
      }
      case Step.TRANSPORT_VOUCHER_GENERATION: {
        dispatch(addCustomerEntry(CustomerEntryName.TRANSPORT_VOUCHER_GENERATION_ACTION, reset ? '' : dataValue?.value));
        break;
      }
      case Step.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT: {
        dispatch(addCustomerEntry(CustomerEntryName.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT, dataValue?.value));
        break;
      }
      case Step.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION_ACTION, dataValue?.value));
        break;
      }
      case Step.REFERENTIAL_ITEMS: {
        dispatch(addCustomerEntry(CustomerEntryName.IS_RIGHT_GOOD, dataValue));
        break;
      }
      case Step.COMPLAINED_TO_MERCHANT_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.COMPLAINED_TO_MERCHANT_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.THEFT_INSURED_PERSON_ELIGIBILITY: {
        dispatch(addCustomerEntry(CustomerEntryName.THEFT_INSURED_PERSON_ELIGIBILITY, dataValue?.value));
        break;
      }
      case Step.CUSTOMER_SPECIFY_PROPERTY: {
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_SPECIFY_PROPERTY, dataValue));
        break;
      }

      case Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.CAPITAL_ADDRESS, dataValue?.value));
        break;
      }
      case Step.DAMAGED_GOOD_PURCHASE_DATE: {
        dispatch(addCustomerEntry(CustomerEntryName.DAMAGED_GOOD_PURCHASE_DATE, dataValue));
        break;
      }
      case Step.ANOTHER_INSURER: {
        dispatch(addCustomerEntry(CustomerEntryName.ANOTHER_INSURER, dataValue?.value));
        break;
      }
      case Step.CONDITION_OF_PROPERTY: {
        dispatch(addCustomerEntry(CustomerEntryName.CONDITION_OF_PROPERTY, dataValue?.value));
        break;
      }
      case Step.METHOD_OF_PAYMENT_CONFIRMATION: {
        dispatch(addCustomerEntry(CustomerEntryName.METHOD_OF_PAYMENT_CONFIRMATION, dataValue?.value));
        break;
      }
      case Step.DECLARE_ANOTHER_DAMAGE: {
        dispatch(addCustomerEntry(CustomerEntryName.DECLARE_ANOTHER_DAMAGE, dataValue?.value));
        break;
      }
      case Step.CUSTOMER_CREDIT_CARD: {
        dispatch(addCustomerEntry(CustomerEntryName.CUSTOMER_CREDIT_CARD, dataValue));
        break;
      }
      case Step.DECLARATION_SUMMARY: {
        dispatch(addCustomerEntry(CustomerEntryName.DECLARATION_CHECKED, dataValue.isChecked.toString()));
        dispatch(addCustomerEntry(CustomerEntryName.RECAPTCHA_VALUE, dataValue.reCaptchaValue));
        break;
      }
      default:
        break;
    }
  }
};

export const loadStepsDatas = (steps: any[], globalData, cmsContent, behaviors, nextInsuredGroupIndex) => async (dispatch, getState) => {
  // On boucle sur les steps renvoyés par le moteur d'étape
  for (const step of steps) {
    if (nextInsuredGroupIndex === null || nextInsuredGroupIndex === undefined) {
      // Si on retrouve des réponses du nouvel écran dans le globalData et que l'on a pas de behavior DONT_RELOAD_DATA
      // on raffraichi le declarationGlobalData et les customerEntry à partir de ces données
      if (globalData[Step[step]] && (isEmptyObject(behaviors) || !behaviors[StepEngineBehaviorsConstants.DONT_RELOAD_DATA])) {
        await dispatch(computeStepEngineDatas(Step[step], globalData[Step[step]]));
        await dispatch(addGlobalData(Step[step], globalData[Step[step]]));
        await dispatch(setCurrentRepeatableStepGroup(null));
        await dispatch(setLastEditStep(Step[step]));
      }
    } else {
      if (globalData.insuredGoods[nextInsuredGroupIndex]
        && globalData.insuredGoods[nextInsuredGroupIndex][Step[step]]
        && (isEmptyObject(behaviors) || !behaviors[StepEngineBehaviorsConstants.DONT_RELOAD_DATA])) {
        await dispatch(computeStepEngineDatas(Step[step], globalData.insuredGoods[nextInsuredGroupIndex][Step[step]]));
        await dispatch(addRepeatableGlobalData(Step[step], globalData.insuredGoods[nextInsuredGroupIndex][Step[step]], nextInsuredGroupIndex));
        await dispatch(setCurrentRepeatableStepGroup(nextInsuredGroupIndex));
        await dispatch(setLastEditStep(Step[step]))
      }
    }


    // Si le contenu prismic n'est pas encore en session on le charge
    if (!cmsContent[Step[step]]) {
      await dispatch(loadPageContent(Step[step]));
    }
  }
};

// Test du behaviors pour execution de la détection des refus
export const checkRefusals = (step: any, globalData, cmsContent, stepList) => async dispatch => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.DETECT_REFUSAL)) {
    await dispatch(detectRefusal(globalData, cmsContent, stepList));
  }
};

// Test du behaviors pour création d'un contact
export const createContactFirstStep = (step: any, globalData, cmsContent, isMobileChannel) => async dispatch => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.CREATE_FIRST_CONTACT)) {
    const contactDTO = new ContactDTO(null, globalData?.clientNumber, globalData?.subscriptionNumber, isMobileChannel);
    await dispatch(createFirstContact(contactDTO));
  }
};

// Test du behaviors pour execution de la création du sinistre
export const checkCreateClaim = (step: any, declarationGlobalData, cmsContent, stepList) => async (dispatch, getState) => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.SAVE_DECLARATION)) {
    await dispatch(claimTransmit(declarationGlobalData, cmsContent, stepList));
  }
};

// Test du behaviors pour execution de la création du sinistre Sherpa Sim
export const checkCreateClaimSherpaSim = (step: any, declarationGlobalData, behaviors, stepList) => async (dispatch, getState) => {
  if (nextBehaviorExist(behaviors, StepEngineBehaviorsConstants.SAVE_SHERPA_SIM_DECLARATION)) {
    await dispatch(claimSherpaSimTransmit(declarationGlobalData, behaviors, stepList));
  }
};
// Test du behaviors pour execution de la création du sherpa document
export const checkCreateSherpaDocument = (declarationGlobalData, behaviors) => async (dispatch, getState) => {
  if (nextBehaviorExist(behaviors, StepEngineBehaviorsConstants.SAVE_SHERPA_SIM_DOCUMENT)) {
    await dispatch(uploadSherpaDocument(declarationGlobalData[Step.CLAIM_DOCUMENT]));
  }
};
// Test du behaviors pour creer une tache
export const checkCreateWorkflow = (createWorkflowDTO, behaviors) => async (dispatch, getState) => {
  if (nextBehaviorExist(behaviors, StepEngineBehaviorsConstants.CREATE_WORKFLOW)) {
    await dispatch(workflowSherpaSimTransmit(createWorkflowDTO));
  }
};

// Test du behaviors pour execution de l'update de L'adress de Shipping
export const checkUpdateClientAdress = (step: any, cmsContent) => async (dispatch, getState) => {
  const { subscriber } = getState().kubrickManagement;
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.UPDATE_CLIENT_ADRESS)) {
    await updateClient(subscriber, dispatch);
  }
};

// Test du behaviors pour execution de l'appel de API FeedBack
export const checkShowRatingModal = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.SHOW_RATING_MODAL]) {
    await dispatch(setShowRatingModal(true));
  }
};

export const checkDontShowPopupRedirectUrl = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.dontShowPopupRedirectUrl) {
    await dispatch(setDontShowPopupRedirectUrl(behaviors?.dontShowPopupRedirectUrl));
  }
};

export const checkStepGroup = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.stepGroup) {
    await dispatch(setStepGroup(behaviors?.stepGroup));
  }
};

export const checkShowStepAction = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.showStepAction) {
    await dispatch(setShowStepAction(behaviors?.showStepAction));
  }
};

// Test du behaviors cover
export const checkCoverBehaviors = (step: any, globalData, behaviors) => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.COVER]) {
    await dispatch(addCustomerEntry(CustomerEntryName.COVER_CHOICE, behaviors[StepEngineBehaviorsConstants.COVER]));
    await dispatch(setCover(behaviors[StepEngineBehaviorsConstants.COVER]));

    const coverObject = {
      ...globalData[Step.COVER_SELECTION],
      code: CoverCode[behaviors[StepEngineBehaviorsConstants.COVER]],
      value: behaviors[StepEngineBehaviorsConstants.COVER],
    };
    console.log('checkCoverBehaviors', coverObject);
    await dispatch(addGlobalData(Step.COVER_SELECTION, coverObject));
  }
};

export const checkJourneyDataBehaviors = behaviors => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.journeyData) {
    for (const key of Object.keys(behaviors.journeyData.customerEntry)) {
      await dispatch(addCustomerEntry(CustomerEntryName[key], behaviors.journeyData.customerEntry[key]));
    }

    await dispatch(setCover(behaviors.journeyData.cover));
  }
};

// Test du behaviors InitDamagedGoods
export const checkInitDamagedGoodsBehaviors = (behaviors, insuredGoods) => async dispatch => {
  if (!isEmptyObject(behaviors) && behaviors[StepEngineBehaviorsConstants.INIT_DAMAGED_GOODS]) {
    await dispatch(addGlobalData(Step.DAMAGED_GOOD_SELECTION, insuredGoods));
  }
};

// Test du behaviors
export const checkDepositMethodBehaviors = (step: any, cmsContent) => dispatch => {
  if (behaviorStepExist(cmsContent, step, StepEngineBehaviorsConstants.DEPOSIT_METHOD)) {
    dispatch(removeBehavior(Step[step], StepEngineBehaviorsConstants.DEPOSIT_METHOD));
  }
};

// Test du behaviors geoLocationPostAction
export const checkGeoLocationPostActionBehaviors = behaviors => async (dispatch, getState) => {
  const { claimNumber } = getState().claim;
  const { subscription } = getState().kubrickManagement;
  const { stepData } = getState().stepEngine;
  const { isMobile } = getState().cms;
  if (!isEmptyObject(behaviors) && behaviors?.geoLocationPostAction) {
    const geolocationPostActionDTO: GeolocationPostActionDTO = {
      type: behaviors.geoLocationPostAction,
      claimNumber,
      subscriptionNumber: subscription?.subscriptionNumber,
      clientNumber: subscription?.subscriber?.number,
      currentStep: stepData.currentSteps[0],
      url: location.href + '/' + stepData.currentSteps[0] + '/' + subscription?.subscriptionNumber + '/' + claimNumber,
      mobile: isMobile,
    };

    await dispatch(geoLocationPostAction(geolocationPostActionDTO));
  }
};

// Test du behaviors
export const checkBackToHomeBehaviors = behaviors => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.backToHome) {
    dispatch(setBackToHome(true));
  }
};

// Test du behaviors RedirectToLounge
export const checkRedirectToLoungeBehaviors = (behaviors: any) => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.[StepEngineBehaviorsConstants.REDIRECT_TO_LOUNGE]) {
    dispatch(redirectToLounge(behaviors.redirectToLounge));
  }
};

// Initialise la liste des steps/réponses à tagger dans GTM
export const checkGtmTagStepsBehaviors = behaviors => dispatch => {
  if (!isEmptyObject(behaviors) && behaviors?.gtmTagSteps) {
    dispatch(initializeGtmTagSteps(behaviors.gtmTagSteps));
  }
};

// GTM : On tag step/reponse dans GTM si question dans gtmTagSteps et label/reponse dans mappers
export const addGtmTagSteps = (currentSteps: string[], globalData, gtmTagSteps: string[], cmsContent) => dispatch => {
  for (const step of currentSteps) {
    const event = gtmStepsMapper(step, globalData);
    const gtmLabelStep = cmsContent[Step[step]]?.prismic?.gtmLabel;
    if (gtmTagSteps.includes(step) && gtmLabelStep !== undefined && event !== undefined) {
      dispatch(gtmEvent(gtmLabelStep, event, '0'));
    }
  }
};

// FIXME: on passe 2 fois dans cette méthode, uniquement quand on a un choix double (ex : cover selection)
export const getNextStep = () => async (dispatch, getState) => {
  let { stepData } = getState().stepEngine;
  const { globalData, declarationGlobalData, components, stepList } = getState().stepEngine;
  const { gtmTagSteps } = getState().gtm;
  const { cmsContent, isMobile } = getState().cms;
  const currentSteps: any[] = stepData.currentSteps;
  try {
    dispatch(startLoading());
    if (!isMobile) {
      // Skeleton : Attribut pour afficher le skeleton : skeleton standart
      await dispatch(setReceivedStep(null));
    }
    // GTM  : Action Suivant
    dispatch(addGtmEventFromNavigation(currentSteps, cmsContent, 'Suivant'));
    // GTM : check gtmTagSteps et mappers puis tag label/réponse dans GTM
    dispatch(addGtmTagSteps(currentSteps, declarationGlobalData, gtmTagSteps, cmsContent));

    // Si on a un behaviors 'goToPreviousStep' sur la page courante, on redirige vers sa valeur, puis on le supprime de la step
    // le moteur d'étape ne sera pas appelé
    if (
      behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP) &&
      !behaviorStepExist(cmsContent, currentSteps[0], StepEngineBehaviorsConstants.GO_TO_NEXT_STEP)
    ) {
      await dispatch(setCurrentStep(cmsContent[Step[currentSteps[0]]]?.behaviors?.goToPreviousStep));
      await dispatch(removeBehavior(Step[currentSteps[0]], StepEngineBehaviorsConstants.GO_TO_PREVIOUS_STEP));
    } else {
      await dispatch(createContactFirstStep(currentSteps[0], globalData, cmsContent, isMobile));
      await dispatch(checkRefusals(currentSteps[0], globalData, cmsContent, stepList));
      await dispatch(checkUpdateClientAdress(currentSteps[0], cmsContent));
      // await dispatch(checkCreateClaim(currentSteps[0], declarationGlobalData, cmsContent, stepList));

      // Recharger le stepData depuis le reducer
      stepData = getState().stepEngine?.stepData;
      // Appel au moteur d'étape pour récupérer les prochaines steps
      const response = await stepEngineApi.nextStep(stepData);
      if (response?.status === 200 || response?.status === 201) {
        const { data } = response || {};
        if (data) {
          const { steps, behaviors } = data || {};
          if (steps) {
            await dispatch(checkCreateClaimSherpaSim(steps[0], declarationGlobalData, behaviors, stepList));
            const createWorkflowParams = new CreateWorkflowDTO(
              getState().claim['idSinistre'],
              getState().claim['idClient'],
              getState().claim['idContact']
            );
            await dispatch(checkCreateSherpaDocument(declarationGlobalData, behaviors));
            await dispatch(checkCreateWorkflow(createWorkflowParams, behaviors));

            await dispatch(checkShowRatingModal(behaviors));
            // Chargement des données des steps (declarartionGlobalData/customerEntry/prismic)
            await dispatch(checkResetStepEngine(behaviors));
            // Attribut pour afficher le skeleton : skeleton spécifique
            await dispatch(setReceivedStep(steps));
            // Ajout du code produit de la carte dans customerEntry
            await dispatch(checkIdProductCard(behaviors));

            // GTM : Initialisation des steps qu'on souhaite taggé dans GTM (question/réponse)
            await dispatch(checkGtmTagStepsBehaviors(behaviors));
            // On initialise les éléments sinistrés avec les éléments assurés de l'adhésion
            await dispatch(checkInitDamagedGoodsBehaviors(behaviors, stepData.subscriptionDto.insuredGoods));

            // // Si on ne reçoit pas le behaviors 'provokeBackward', on ajoute les steps courantes dans PreviousStep
            // await dispatch(checkNoBackwardBehaviors(steps, currentSteps, cmsContent));

            let nextInsuredGroupIndex = null;

            const isNewRepeatableStepGroup = ((behaviors.lastRepeatableStepGroup !== undefined && stepData.lastRepeatableStepGroup === null)
              || (behaviors.lastRepeatableStepGroup > stepData.lastRepeatableStepGroup))
              && (stepData.lastRepeatableStepGroup === stepData.currentRepeatableStepGroup)
              && behaviors.repeatableStep;

            // TODO: si édition, ne pas incrémenter
            if (behaviors.repeatableStep) {
              if (isNewRepeatableStepGroup) {
                nextInsuredGroupIndex = behaviors.lastRepeatableStepGroup;
              } else if ((behaviors.lastRepeatableStepGroup > stepData.lastRepeatableStepGroup)
                && stepData.currentRepeatableStepGroup !== null
                && (stepData.lastRepeatableStepGroup > stepData.currentRepeatableStepGroup)) {
                nextInsuredGroupIndex = stepData.currentRepeatableStepGroup + 1;
              } else {
                nextInsuredGroupIndex = (stepData.currentRepeatableStepGroup !== null ? stepData.currentRepeatableStepGroup : 0);
              }
            }

            // Chargement des données des steps (declarartionGlobalData/customerEntry/prismic)
            await dispatch(loadStepsDatas(steps, globalData, cmsContent, behaviors, nextInsuredGroupIndex));

            // ??? Si on trouve un behaviors 'depositMethod', on le supprime
            await dispatch(checkDepositMethodBehaviors(Step[currentSteps[0]], cmsContent));

            // TODO: recharger la stepList pour tester que ça passe plus 2 fois sur l'insertion et la suppresion de step
            // !!! A REGARDERRRR !!! -> s'en servir sur les doubles appels dérangeant (exemple : addNextStepToStepList et removeStepFromStepListByIndexAndName)
            // stepList = getState().stepEngine?.stepList;

            // TODO: en faire une méthode réutilisable dans ce service ??
            if (stepList.findIndex(x => x.stepName === steps[0] && x.insuredGroupIndex === nextInsuredGroupIndex) === -1) {
              const tempCurrentStepIndex = stepList.findIndex(x => x.stepName === currentSteps[0] && x.insuredGroupIndex === stepData.currentRepeatableStepGroup);
              const tempStep: StepList = {
                stepGroup: behaviors.stepGroup,
                stepName: steps[0],
                disableNextButton: true,
                insuredGroupIndex: nextInsuredGroupIndex, // behaviors.repeatableStep ? insuredGoods.length() : null,
                component: components[Step[steps[0]]]
              }
              await dispatch(addNextStepToStepList(tempStep, tempCurrentStepIndex + 1))
              // TODO: revoir, pb d'ordre d'exécution. Solution possible : fusionner addNextStepToStepList && setLastRepeatableStepGroup && setCurrentStep ??
              if (isNewRepeatableStepGroup)
                dispatch(setLastRepeatableStepGroup(behaviors.lastRepeatableStepGroup))
            } else { // Si la step est déjà incluse, on check si les steps entre la step modifiée et la prochaine step sont toujours utile, si non, on supprime
              // TODO: les deux prochains avec nextInsuredGroupIndex
              const currentStepIndex = stepList.findIndex(x => x.stepName === currentSteps[0] && x.insuredGroupIndex === stepData.currentRepeatableStepGroup)
              const nextStepIndex = stepList.findIndex(x => x.stepName === steps[0] && x.insuredGroupIndex === nextInsuredGroupIndex)
              const stepsDelta = nextStepIndex - currentStepIndex

              if (stepsDelta > 1) { // Si des steps existe entre la courante et la prochaine
                for (let i = nextStepIndex - 1; i > currentStepIndex; i--) { // C'est un tableau donc on le dépile
                  // Multi passage, obligé de sécuriser la suppression avec le nom
                  if (stepList[i].stepName !== steps[0]) // await dispatch(removeStepFromStepList(i))
                    dispatch(removeStepFromStepListByIndexAndName(i, stepList[i].stepName))
                }
              }
            }

            // On met à jour les currentSteps
            await dispatch(setCurrentRepeatableStepGroup(nextInsuredGroupIndex));
            await dispatch(setCurrentStep(steps));

            await dispatch(checkDontShowPopupRedirectUrl(behaviors));
            await dispatch(checkStepGroup(behaviors));
            await dispatch(checkShowStepAction(behaviors));

            if (!isEmptyObject(behaviors)) {
              // On stocke les behaviors renvoyés par le moteur d'étape dans le store
              for (const step of steps) {
                await dispatch(addBehaviors(Step[step], behaviors));
              }
            } else {
              await dispatch(setShowStepAction(true));
            }
            // Si on a reçu le behaviors cover, on ajoute la customerEntry et on modifie la cover avec cette valeur
            await dispatch(checkCoverBehaviors(currentSteps[0], globalData, behaviors));
            await dispatch(checkJourneyDataBehaviors(behaviors));
            await dispatch(manageModal(cmsContent, behaviors));

            await dispatch(checkBackToHomeBehaviors(behaviors));

            // // Si on recoit le behaviors addPreviousStep on ajoute le previousStep
            // await dispatch(addPreviousStepFromBehaviors(behaviors));
          } else {
            // await dispatch(setShowStepAction(true));
            // Si on recoit le behaviors RedirectToLoungeBehaviors
            await dispatch(checkRedirectToLoungeBehaviors(behaviors));
          }
          await dispatch(checkGeoLocationPostActionBehaviors(behaviors));
        }
      }
    }
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    throw error;
  }
};

export const getSpecificStepFromEvent = (param: any) => async (dispatch, getState) => {
  try {
    dispatch(startLoading());
    await dispatch(findClaim(param.claimNumber));
    const claim: ClaimState = getState().claim;
    dispatch(addCustomerEntry(CustomerEntryName.FROM_SPECIFIC_STEP, '1'));
    dispatch(addCustomerEntry(CustomerEntryName.CLAIM_NUMBER, param.claimNumber));
    const currentStepIndex = param.stepData.stepList.findIndex(
      x => x.stepName === param.stepData.stepData.currentSteps[0] && x.insuredGroupIndex === param.stepData.stepData.currentRepeatableStepGroup)
    dispatch(setCurrentRepeatableStepGroup(param.stepData.stepList[currentStepIndex].insuredGroupIndex))
    dispatch(setCurrentStep([param.stepName]));
    dispatch(stopLoading());
    await dispatch(getNextStep());
  } catch (error) {
    dispatch(stopLoading());
    location.replace('/');
    throw error;
  }
};
export const getSpecificStep = specificStep => async (dispatch, getState) => {
  const { cmsContent } = getState().cms;
  try {
    dispatch(startLoading());

    const response = await stepEngineApi.specificStep(specificStep);

    if (response.status === 200 || response.status === 201) {
      if (response.data?.steps) {
        const { steps, behaviors } = response.data;

        dispatch(setCurrentStep(steps));
        steps.map(step => {
          if (!cmsContent[Step[step]]) {
            dispatch(loadPageContent(Step[step]));
          }
        });
        if (behaviors && Object.keys(behaviors).length > 0) {
          const { showStepAction, showModal, cover } = behaviors;

          steps.map(step => {
            dispatch(addBehaviors(Step[step], behaviors));
            if (!showStepAction) {
              dispatch(setShowStepAction(showStepAction));
            } else dispatch(setShowStepAction(true));
          });
          if (showModal) {
            if (!cmsContent[ModalConstants[showModal]]) {
              dispatch(loadModalContent(ModalConstants[showModal]));
            }
            dispatch(setShowErrorModal(true));
          }
          if (cover === 'OXIDATION') {
            dispatch(addCustomerEntry(CustomerEntryName.COVER_CHOICE, cover));
            dispatch(setCover(cover));
          }
        }
      }
    } else {
      // No response from the backend
    }
  } catch (error) {
    dispatch(stopLoading());
    location.replace('/');
    throw error;
  }
};

export const getSpecificStepBehaviors = (specificStepName, deviceType) => async dispatch => {
  try {
    dispatch(startLoading());

    // Appel au moteur d'étape pour récupérer les behaviors de step
    const response = await stepEngineApi.specificStep({ requestStep: specificStepName, deviceType });
    if (response?.status === 200 || response?.status === 201) {
      if (response?.data?.behaviors) {
        const { behaviors } = response.data || {};
        if (behaviors && Object.keys(behaviors).length > 0) {
          await dispatch(addBehaviors(Step[specificStepName], behaviors));
        }
      }
    }
    dispatch(stopLoading());
  } catch (error) {
    dispatch(stopLoading());
    throw error;
  }
};

export const hidePreviousButton = (cmsContent, currentStep: string) => {
  return behaviorStepExist(cmsContent, currentStep, StepEngineBehaviorsConstants.HIDE_PREVIOUS_BUTTON);
};

export const hideNextButton = (cmsContent, currentStep: string) => {
  return behaviorStepExist(cmsContent, currentStep, StepEngineBehaviorsConstants.HIDE_NEXT_BUTTON);
};
